"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetLoginPwdWithDynCodeRequest = void 0;
var ResetLoginPwdWithDynCodeRequest = /** @class */ (function () {
    function ResetLoginPwdWithDynCodeRequest() {
    }
    return ResetLoginPwdWithDynCodeRequest;
}());
exports.ResetLoginPwdWithDynCodeRequest = ResetLoginPwdWithDynCodeRequest;
;
//# sourceMappingURL=resetLoginPwdWithDynCode.request.js.map